'use strict';

var activeMenuItem;
var activeSubmenu;
var mainMenuActive = false;
var mainMenuPadActive = false;
var filterOpen = false;
var sortorderOpen = false;
var browserHeight = $(window).height(),
    browserWidth = $(window).width(),
    isMobile = false;

if (browserWidth < 800) {
    isMobile = true;
}

var tempvar1 = Math.round(browserHeight * 0.5);
var navHeight;

$('.nav-ul').css('height', browserHeight - 420 + 'px');

$(window).resize(function () {
    browserHeight = $(window).height();
    $('.nav-ul').css('height', browserHeight - 420 + 'px');
});

function ToggleMenu(isDesktop) {
    if (mainMenuActive) {

        var tl = new TimelineMax();

        tl.fromTo($('.nav-ul li.level0'), 0.3, {
            opacity: 1
        }, {
            opacity: 0
        }, 0.1);

        tl.fromTo($('.search-container'), 0.3, {
            y: 0,
            opacity: 1
        }, {
            y: -20,
            opacity: 0,
            ease: Power4.easeOut,
            onComplete: function onComplete() {
                $('.circle-expand').removeClass('expand');
                $('.nav-icon').removeClass('open');
                $('nav').css('display', 'none');
                $('.nav-bottom').removeClass('active');
            }

        }, "-=0.1");

        tl.fromTo($('.nav-bottom'), 0.3, {
            y: 0,
            opacity: 1
        }, {
            y: 20,
            opacity: 0,
            ease: Power4.easeOut

        }, "-=0.1");

        if (isDesktop) {
            $('.nav-icon-desktop').removeClass('open');

            tl.fromTo($('.teaser-text'), 0.3, {
                y: -20,
                opacity: 0
            }, {
                y: 0,
                opacity: 1,
                ease: Power4.easeIn

            }, "+=0.1");
        }

        mainMenuActive = false;
    } else {
        $('.circle-expand').addClass('expand');
        $('.nav-icon').addClass('open');
        $('nav').css('display', 'block');
        $('.nav-bottom').addClass('active');

        var _tl = new TimelineMax();

        _tl.fromTo($('.search-container'), 0.3, {
            y: -20,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            ease: Power4.easeOut

        }, "+=0.3");

        _tl.staggerFromTo($('.nav-ul li.level0'), 0.3, {
            y: 20,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            ease: Power4.easeOut
        }, 0.05, "-=0.3");

        if (isDesktop) {

            $('.nav-icon-desktop').addClass('open');

            _tl.fromTo($('.teaser-text'), 0.3, {
                y: 0,
                opacity: 1
            }, {
                y: 20,
                opacity: 0,
                ease: Power4.easeIn

            }, "-=1.0");
        }

        _tl.fromTo($('.nav-bottom'), 0.5, {
            y: 20,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            ease: Power4.easeOut

        }, "-=0.1");

        mainMenuActive = true;
    }
}

function TogglePadMenu() {

    if (mainMenuPadActive) {
        $('header').addClass('minimize');
        $('.nav-icon-pad').addClass('minimize');
        mainMenuPadActive = false;
    } else {
        $('header').removeClass('minimize');
        $('.nav-icon-pad').removeClass('minimize');
        mainMenuPadActive = true;

        $('.cta-section, .article-content').bind('click', function (e) {
            TogglePadMenu();
            $('.cta-section, .article-content').unbind('click');
        });
    }
}

function ToggleMenuItem(event) {
    if (activeMenuItem !== $(event.target)) {
        activeMenuItem = $(event.target);
        var SendButton = $(event.target);

        var anchor = $(SendButton).closest('a');
        if (activeSubmenu === anchor) {

            $(anchor).siblings('ul').toggleClass('toggled');
        } else {
            $(activeSubmenu).siblings('ul').toggleClass('toggled');
            activeSubmenu = anchor;

            $(anchor).siblings('ul').toggleClass('toggled');
        }
        $(SendButton).removeClass('inactive');
    }
}

$(function () {
    if (!isDevice) {
        $(' ul.children .sublink ').each(function () {
            $(this).hoverdir();
        });
    }
});

$('a[href*="#"]:not([href="#"])').click(function () {
    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 1000);
            return false;
        }
    }
});

function gotoId(getid, offset) {
    var target = $(getid);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

    if (target.length) {
        $('html, body').animate({
            scrollTop: target.offset().top - offset
        }, 1000);
        return false;
    }
}

var isDevice = false;

if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
    isDevice = true;
}

if (isDevice) {
    $('.top-image').bind('touchstart touchend', function (e) {
        $(this).toggleClass('remove-gradient');
    });
}

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.header-bar').outerHeight();
var stickyExtrasHeight = $(window).height() - 100;

setTimeout(function (event) {
    if ($('.cta-section').length > 0) {
        stickyExtrasHeight = Math.floor($('.cta-section').position().top + $('.cta-section').innerHeight());
    }
}, 500);

var removeGradientHeight = $(window).height();
$(window).on('scroll', function (event) {

    if (!mainMenuActive) {
        didScroll = true;
    }

    if (mainMenuPadActive) {
        TogglePadMenu();
        $('.cta-section, .article-content').unbind('click');
    }
});

setInterval(function () {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(window).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $('.header-bar').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        if (st < lastScrollTop) {
            $('.header-bar').removeClass('nav-up').addClass('nav-down');
        }
    }

    if (st > removeGradientHeight) {
        //$('.top-image').addClass('remove-gradient');
    } else {
            // if (st < lastScrollTop) {
            //  $('.top-image').removeClass('remove-gradient');
            //}
        }

    if (st > lastScrollTop && st > stickyExtrasHeight) {
        $('.stickyExtras').removeClass('extras-down').addClass('extras-up');
        $('.stickyExtras').removeClass('extras-makeroom');
    } else {
        if (st < lastScrollTop && st < stickyExtrasHeight) {
            $('.stickyExtras').removeClass('extras-up').addClass('extras-down');
            $('.stickyExtras').removeClass('extras-makeroom');
        } else {
            if (st > stickyExtrasHeight) {
                $('.stickyExtras').addClass('extras-makeroom');
            }
        }
    }

    lastScrollTop = st;
}

function ToggleShareMenu() {
    $('.share-container .icons').addClass('show');
    $('.share-container .share-icon').addClass('hide');
    $('.share-container .header').addClass('hide');

    setTimeout(function () {
        $('.share-container .icons').removeClass('show');
        $('.share-container .share-icon').removeClass('hide');
        $('.share-container .header').removeClass('hide');
    }, 4000);
}

function expandInfoMobile() {
    $('.expand-info#infoboxmobile').addClass('show');
    $('.share-include').addClass('expand');

    setTimeout(function () {
        $('.expand-info#infoboxmobile').removeClass('show');
        $('.share-include').removeClass('expand');
    }, 4000);
}

function expandInfoDesktop() {
    $('.expand-info#infoboxdesktop').addClass('show');
    $('.contact.desktop').addClass('expand');

    setTimeout(function () {
        $('.expand-info#infoboxdesktop').removeClass('show');
        $('.contact.desktop').removeClass('expand');
    }, 10000);
}

function showFiltersMobile() {

    if (filterOpen) {
        $('.filter-options').removeClass('show');
        $('.filter .icon').removeClass('open');
        filterOpen = false;
    } else {
        $('.filter-options').addClass('show');
        $('.filter .icon').addClass('open');
        filterOpen = true;
    }

    if (sortorderOpen) {
        $('.sortorder-options').removeClass('show');
        $('.sortorder .icon').removeClass('open');
        sortorderOpen = false;
    }

    gotoId('#filter', 100);
}

function showSortOrder() {

    if (sortorderOpen) {
        $('.sortorder-options').removeClass('show');
        $('.sortorder .icon').removeClass('open');
        sortorderOpen = false;
    } else {
        $('.sortorder-options').addClass('show');
        $('.sortorder .icon').addClass('open');
        sortorderOpen = true;
    }

    if (filterOpen) {
        $('.filter-options').removeClass('show');
        $('.filter .icon').removeClass('open');
        filterOpen = false;
    }

    gotoId('#filter', 100);
}

function keydown(e) {
    if (e.ctrlKey && e.keyCode === 116 || e.ctrlKey && e.keyCode === 82) {
        window.location.href = window.location.pathname + "?" + $.param({ 'fetchNew': 'true' });
        if (e.preventDefault) {
            e.preventDefault();
        } else {
            return false;
        }
    }
}

function ShareToFacebook() {
    var url = document.getElementById('someFB').dataset.url;
    var shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
    window.open(shareUrl);
}

$(document).keydown(keydown);

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search.substr(1).split("&").forEach(function (item) {
        tmp = item.split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
    return result;
}

var isDevice = false;

if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
    isDevice = true;
}

function btnAnimation() {
    document.getElementById('submit-btn').classList.add('loading');
    document.getElementById('checkmarkitem3path').classList.add('loader-animation');
}

var setEventForBlur = function () {
    var allControlsWithFormControlClass = document.getElementsByClassName("form-control");
    for (var _i = 0; _i < allControlsWithFormControlClass.length; _i++) {
        var element = allControlsWithFormControlClass[_i];
        element.addEventListener('blur', blurControl, true);
    }
}();

function blurControl(e) {
    var elementTriggered = e.target;
    if (elementTriggered) {
        if (elementTriggered.value.length > 0) {
            elementTriggered.classList.add("has-content");
        } else {
            elementTriggered.classList.remove("has-content");
        }
    }
}

var allForms = $('.form-control');
for (var i = 0; i < allForms.length; i++) {
    if ($(allForms[i]).val().length > 0) {
        $(allForms[i]).addClass('has-content');
    }
}

if (isDevice) {
    $('.mobil-magic-hover').bind('touchstart touchend', function (e) {
        $(this).toggleClass('highlight');
    });
}

function SetActiveMenu() {
    var currentUrl = window.location.pathname;
    var resultMenuPath = currentUrl;

    //Vi sjekker om menupath har flere enn 2 nivåer(/). Vi trenger kun 2 nivåer siden menyen kun har 2.
    var splittedMenuPath = currentUrl.split('/');
    if (splittedMenuPath.length > 3) {
        resultMenuPath = "";
        for (var j = 1; j < 3; j++) {
            resultMenuPath += "/" + splittedMenuPath[j];
        }
    }

    var allTopMenuItems = $('nav .nav-ul a');
    for (var i = 0; i < allTopMenuItems.length; i++) {
        var currentAnchorPath = allTopMenuItems[i].href.replace(window.location.origin, '');
        if (currentAnchorPath === resultMenuPath) {
            if ($(allTopMenuItems[i]).hasClass('child-menu-item')) {
                $(allTopMenuItems[i]).addClass('active');
                $(allTopMenuItems[i]).children('sublink').addClass('active');
                $(allTopMenuItems[i]).closest('ul.children').addClass('toggled');

                $(allTopMenuItems[i]).parent().parent().parent().find('.parent-menu-item').addClass('active-parent');
            } else {
                $(allTopMenuItems[i]).addClass('active');
            }
        }
    }
}

var modalFullScreenIsShown = false;

function ShowModalFullscreen(callback) {
    $("#modalFullscreen").show();
    modalFullScreenIsShown = true;
    if (callback) {
        callback();
    }

    return false;
}

function HideModalFullscreen(callback) {
    $("#modalFullscreen").hide();
    modalFullScreenIsShown = false;
    if (callback) {
        callback();
    }

    return false;
}

SetActiveMenu();